// import lazy from 'Snippets/LazyLoad'

export { default as Collapse } from './Collapse'

export { default as Modal } from './Modal'
